import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

import { LoadingService } from './core/services/loading.service';
import { LoginService } from './proxy/services/login.service';
import { ExecutionStatus } from './proxy/models/common';
import { AllLookupsService } from './core/services/all-lookups.service';
import { UserService } from './core/services/user.service';
import { RecaptchaLoaderService } from './core/services/recaptcha-loader.service';
import { MainLoadingComponent } from './shared/components/main-loading/main-loading.component';
import { PromptUpdateService } from './core/services/prompt-update.service';
import {
    NewVersionConfirmationDialog,
} from './shared/components/new-version-confirmation-dialog/new-version-confirmation-dialog';
import {
    NewVersionConfirmationService,
} from './shared/components/new-version-confirmation-dialog/new-version-confirmation.service';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        MainLoadingComponent,
        NewVersionConfirmationDialog,
    ],
    providers: [
        PromptUpdateService,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    public destroyRef = inject(DestroyRef);
    private promptUpdateService = inject(PromptUpdateService);

    public loadingService = inject(LoadingService);
    private loginService = inject(LoginService);
    private lookupsService = inject(AllLookupsService);
    private userService = inject(UserService);
    private router = inject(Router);
    private cdr = inject(ChangeDetectorRef);
    private recaptchaLoaderService = inject(RecaptchaLoaderService);
    public newVersionConfirmationService = inject(NewVersionConfirmationService);

    constructor() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((event: any) => {
            this.lookupsService.removeIsLookupReady();
            if (event.url !== '/' && event.url !== '/sal-terms-and-conditions' &&
                event.url !== '/pfra-terms-and-conditions') {
                this.loadingService.showLoader();
                this.login();
            }
        });

        this.recaptchaLoaderService.loadRecaptcha();
    }

    private login(): void {
        this.loginService.validateLogin().pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe({
            next: (loginRes) => {
                if (loginRes.result.status === ExecutionStatus.success) {
                    this.userService.saveUser(loginRes.enrichedUsr);
                    this.lookupsService.getAllLookups().pipe(
                        takeUntilDestroyed(this.destroyRef),
                    ).subscribe({
                        next: (res) => {
                            if (res?.records?.length) {
                                const data = JSON.parse(res.records?.[0]?.LookupTableJson)?.LookupTables;
                                this.lookupsService.setLookups(data);
                                this.lookupsService.setIsLookupReady();
                            }
                            this.hideLoader();
                        },
                        error: () => this.hideLoader()
                    });
                } else {
                    this.hideLoader();
                }
            },
            error: () => this.hideLoader()
        });
    }

    private hideLoader(): void {
        this.loadingService.hideLoader();
        this.cdr.markForCheck();
    }
}
